const brandUtil = {
  methods: {
    normalizeAccentedBrandName (brand) {
      return brand
        .normalize('NFD')
        .replace(/[\u0300-\u036F]/g, '')
        .toLowerCase()
    }
  }
}

export { brandUtil }
